import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import AutoCreatedTag from "../AutoCreatedTag/AutoCreatedTag";

export const StyledPrimaryContent = styled.div`
    flex-shrink: 0;
`;

export const StyledSecondaryText = styled.span`
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon["250"])};
    line-height: 20px;
`;

export const StyledItemInfoSection = styled(FlexRow)`
    margin-top: 12px;
`;

export const StyledItemTitleText = styled.h4`
    display: flex;
    align-items: center;
    margin: 0;
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["400"])};
    ${mixins.truncateText()};
`;

export const StyledAutoCreatedTag = styled(AutoCreatedTag)`
    margin-left: 8px;
`;

export const StyledItemBody = styled.div`
    flex-grow: 1;
    min-width: 0;
    padding-right: 16px;
`;

export const StyledItemIconWrapper = styled.div`
    flex-shrink: 0;
    padding: 0 16px;
`;

export const StyledItemWrapper = styled(FlexRow)<{ index: number }>`
    background-color: ${colorsPalettes.carbon["0"]};
    border: 1px solid ${colorsPalettes.carbon["50"]};
    border-radius: 8px;
    box-sizing: border-box;
    cursor: ${({ onClick }) => (typeof onClick === "function" ? "pointer" : "default")};
    height: 88px;
    transition: box-shadow 100ms ease-in-out;
    user-select: none;

    &.animated {
        animation: slide-up ease-out 400ms ${({ index = 0 }) => index * 50}ms forwards;
        opacity: 0;
        transform: translateY(20px);
    }

    &:hover {
        box-shadow: 0px 18px 34px rgba(14, 30, 62, 0.12);
    }

    @keyframes slide-up {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
